export default __webpack_public_path__ + "static/media/1.4ece2ba2.jpg";